module.exports = __webpack_public_path__ + "assets/img/84dfd79e985efda4ea7d14fbe2aba20f.svg";